module.exports = __webpack_public_path__ + "img/icon_whatsapp.08421af9.svg";